export const generativeAiStandardsRulesetSynthesisUsage =
  "/:app_group_id/generative_ai/standards_ruleset_synthesis_usage";
